export const en = {
  "header": {
    "brand": "CikaStudio",
    "tools": "Tools",
    "games": "Games",
    "about": "About"
  },
  "nav": {
    "tools": "Tools",
    "games": "Games",
    "about": "About"
  },
  "actions": {
    "copy": "Copy",
    "download": "Download",
    "clear": "Clear",
    "copied": "Copied!",
    "copyAll": "Copy All",
    "downloadTxt": "Download TXT",
    "generate": "Generate",
    "regenerate": "Regenerate",
    "format": "Format",
    "minify": "Minify",
    "validate": "Validate",
    "convert": "Convert"
  },
  "footer": {
    "privacy": "Privacy",
    "terms": "Terms",
    "email": "Contact",
    "moreTools": "More Tools",
    "copyright": "© {year} CikaStudio. All rights reserved."
  },
  "language": {
    "en": "English",
    "zh": "中文"
  },
  "theme": {
    "light": "Light",
    "dark": "Dark"
  },
  "common": {
    "clientSide": "100% client-side",
    "noUpload": "No data upload",
    "noAccount": "No account required",
    "loading": "Loading...",
    "error": "Error",
    "success": "Success"
  },
  "imgCompress": {
    "title": "Image Compressor",
    "subtitle": "Compress JPEG, PNG, WebP images online. ",
    "privacy": "100% client-side",
    "noUpload": "no upload needed",
    "uploadTitle": "Upload Images",
    "uploadDesc": "Drag & drop or click to select. Supports JPEG, PNG, WebP, GIF.",
    "addFiles": "Add Images",
    "files": "files",
    "quality": "Quality",
    "qualityDesc": "Higher = better quality, larger file",
    "maxWidth": "Max Width",
    "widthDesc": "Images larger than this will be resized",
    "format": "Output Format",
    "original": "Original",
    "compress": "Compress All",
    "processing": "Processing...",
    "invalidFile": "Please select image files (JPEG, PNG, WebP, GIF)"
  },
  "content": {
    "privacy": {
      "title": "Privacy & Security",
      "description": "🔒 All image compression happens locally in your browser using canvas APIs. Your photos and images are never uploaded to any server, keeping your visual content completely private."
    },
    "guide": {
      "title": "How to Use Image Compressor",
      "description": "Reduce image file sizes for faster websites, social media uploads, and email attachments without leaving your browser.",
      "steps": [
        {
          "title": "Upload your images",
          "description": "Drag and drop one or multiple images (JPG, PNG, WebP, GIF) into the upload area. You can also click to browse your files. Processing starts immediately upon upload."
        },
        {
          "title": "Set compression level",
          "description": "Use the quality slider to balance between file size and visual quality. A preview shows the before and after so you can see the difference in real time."
        },
        {
          "title": "Download compressed files",
          "description": "Once satisfied with the preview, click Download to save the optimized images to your device. File size reduction of 50–90% is common for high-resolution photos."
        }
      ]
    },
    "features": {
      "title": "Key Features",
      "items": [
        "Client-side compression for JPG, PNG, WebP, and GIF formats",
        "Adjustable quality slider with real-time before/after preview",
        "Batch processing for multiple images at once",
        "Preserves original dimensions while optimizing file size",
        "Typical size reduction of 50–90% for photos and screenshots",
        "No server upload — your images stay on your device"
      ]
    },
    "faq": {
      "title": "Frequently Asked Questions",
      "items": [
        {
          "question": "Will compression reduce image quality?",
          "answer": "Some quality reduction occurs at lower settings, but the slider lets you find the perfect balance. For web use, 70–85% quality usually produces files that are much smaller with virtually no visible quality loss."
        },
        {
          "question": "What image formats are supported?",
          "answer": "The tool supports JPG, PNG, WebP, and GIF. Output format matches the input by default. WebP generally offers the best compression ratio for photographs."
        },
        {
          "question": "Is there a file size limit?",
          "answer": "There is no server-enforced limit. The only constraint is your browser memory. Most modern devices can handle images up to 20–50 MB without issues."
        }
      ]
    },
    "related": {
      "title": "Related Tools",
      "tools": [
        {
          "name": "Image Resizer",
          "url": "/image/image-resizer",
          "description": "Resize images to exact dimensions for social media and web use."
        },
        {
          "name": "Image Converter",
          "url": "/image/image-converter",
          "description": "Convert between JPG, PNG, WebP, and other image formats."
        },
        {
          "name": "Image Watermarker",
          "url": "/image/image-watermarker",
          "description": "Add text or logo watermarks to protect your images."
        }
      ]
    }
  }
};
